import React, { useEffect, useRef} from "react";

import "./App.css";
import { ThemeProvider } from "@mui/material";

import { Navbar } from "./customer/components/Navbar";
import customTheme from "./customer/theme/CustomTheme";
import { Home } from "./customer/pages/Home/Home";
import { Product } from "./customer/pages/Product/Product";
import { ProductDetails } from "./customer/pages/PageDetails/ProductDetails";
import { Review } from "./customer/pages/Review/Review";
import { Cart } from "./customer/pages/Cart/Cart";
import { Checkout } from "./customer/pages/Checkout/Checkout";
import { Account } from "./customer/pages/Account/Account";
import { Route, Routes, useNavigate } from "react-router-dom";
import { BecomeSeller } from "./customer/pages/Become Seller/BecomeSeller";
import { SellerDashBoard } from "./seller/pages/SellerDashBoard/SellerDashBoard";
import { AdminDashBoard } from "./admin/pages/DashBoard/AdminDashBoard";
import { useAppDispatch, useAppSelector } from "./State/Store";
import { fetchSellerProfile } from "./State/seller/sellerSlice";
import { Auth } from "./customer/pages/Auth/Auth";
import { fetchUserProfile, validateSession } from "./State/AuthSlice";
import { PaymentSuccess } from "./seller/pages/PaymentSuccess/PaymentSuccess";
import { WishList } from "./customer/pages/WishList/WishList";
import { homeCategories } from "./customer/data/homeCategories";
import PrivateRoute from "./admin/components/PrivateRoute";
import { createCategories } from "./State/admin/categorySlice";
import { mainCategoryReq } from "./customer/data/mainCategory";
import {
  categoryThree,
  categoryTwo,
} from "./customer/components/CategorySheet";
import { ReviewForm } from "./customer/pages/Review/ReviewForm";
import { GlobalLoading } from "./customer/components/GlobalLoading";
import { ErrorGate } from "./customer/components/ErrorGate";
import { createHomeCategories } from "./State/admin/adminSlice";
import { VerifySeller } from "./seller/pages/VerifySeller/VerifySeller";
import { NotFoundPage } from "./seller/pages/NotFoundPage";
import { Footer } from "./customer/components/Footer";

function App() {
  const auth = useAppSelector((store) => store.auth);
  const ui = useAppSelector((store) => store.ui);
  const showGlobalLoading = ui.pendingCount > 0;
  const category = useAppSelector((store) => store.category);
  const didInit = useRef(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    (async () => {
      try {
        await dispatch(validateSession());
        await dispatch(
          createCategories({
            level1Categories: mainCategoryReq,
            level2Categories: Object.values(categoryTwo).flat(),
            level3Categories: Object.values(categoryThree).flat(),
          })
        ).unwrap();
        await dispatch(createHomeCategories(homeCategories)).unwrap();
      } catch (error) {
      } finally {
        //  dispatch(validateSession());
      }
    })();
  }, [dispatch]);

  useEffect(() => {
    if (!auth.isLoggedIn) return; // not logged in yet
    if (!auth.roles || auth.roles.length === 0) return; // roles not loaded yet
    // if(!homeCategory.homePageData==null) return;
    if (auth.roles.includes("ROLE_ADMIN")) {
      dispatch(fetchUserProfile()).unwrap();
    } else if (auth.roles.includes("ROLE_SELLER")) {
      dispatch(fetchSellerProfile());
    } else if (auth.roles.includes("ROLE_CUSTOMER")) {
      dispatch(fetchUserProfile());
    }
  }, [auth.isLoggedIn, auth.roles, dispatch]);
  // Lock/unlock scroll on the document while loading
  useEffect(() => {
    const { style } = document.body;
    const prev = style.overflow;
    if (showGlobalLoading) {
      style.overflow = "hidden";
      window.scrollTo({ top: 0 });
    } else {
      style.overflow = prev || "";
    }
    return () => {
      style.overflow = prev || "";
    };
  }, [showGlobalLoading]);
  //  Object.values(categoryTwo).flat() turn [[],[],[]] into []

  return (
    <ThemeProvider theme={customTheme}>
      {showGlobalLoading && <GlobalLoading />} {/* the only visible thing */}
      <div>
        <ErrorGate>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/:categoryId" element={<Product />} />
            <Route path="/reviews/:productId" element={<Review />} />
            <Route
              path="/reviews/:orderId/:productId/create"
              element={<ReviewForm />}
            />
            <Route
              path="/product-details/:categoryId/:name/:productId"
              element={<ProductDetails />}
            />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<WishList />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/:addressId" element={<Checkout />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/verify-seller/:otp" element={<VerifySeller />} />
            <Route path="/account/*" element={<Account />} />
            <Route path="/become-seller" element={<BecomeSeller />} />
            <Route path="/seller/*" element={<SellerDashBoard />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route
              path="/admin/*"
              element={
                <PrivateRoute requiredRole="ROLE_ADMIN">
                  <AdminDashBoard />
                </PrivateRoute>
              }
            />
            <Route path="/login" element={<Auth />} />
          </Routes>
          <Footer/>
        </ErrorGate>
      </div>
    </ThemeProvider>
  );
}

export default App;
